import type { JSX } from 'react'
import type { ITextBoxProps } from 'atoms/TextBox'
import type { ITextBlockProps } from 'blocks/TextBlock'

import { TextBoxBody4Secondary } from 'atoms/TextBox/Templates'
import {
  TextBlock,
  TextBlockDirection,
  TextBlockRowGap,
} from 'blocks/TextBlock'

export interface ITextBlockNotice extends ITextBlockProps {
  title: ITextBoxProps['title']
  description: ITextBoxProps['title']
}

export const TextBlockNotice = ({
  title,
  description,
  direction = TextBlockDirection.ROW,
  rowGap = TextBlockRowGap.INDENT_40,
  ...rest
}: ITextBlockNotice): JSX.Element => {
  return (
    <TextBlock rowGap={rowGap} direction={direction} {...rest}>
      <TextBoxBody4Secondary>
        {/*this is a white space added to separate two parts of text */}
        {title!}&thinsp;&thinsp;&thinsp;&thinsp;&thinsp;{description!}
      </TextBoxBody4Secondary>
    </TextBlock>
  )
}
